export const buttons = [
  {
    id: 1,
    title: 'Туманлар бўйича',
    value: 'all',
  },
  {
    id: 2,
    title: 'Категориялар бўйича',
    value: 'category',
  },
  {
    id: 3,
    title: 'Субкатегориялар бўйича',
    value: 'subCategory',
  },
  {
    id: 4,
    title: 'Режа(план)лар бўйича',
    value: 'users',
  },
  {
    id: 5,
    title: 'Ташкилотлар бўйича',
    value: 'organization',
  },
];
